import React, { useReducer, useRef, useEffect } from "react";
import { initialState, reducer } from "./Reducer";
import ConfirmContext from "./ConfirmContext";

export const ConfirmContextProvider = ({ children }) => {
    const pending = useRef(null);
    useEffect(() => () => { pending.current?.(false); pending.current = null; }, []);
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <ConfirmContext.Provider value={[state, dispatch, pending]}>
            {children}
        </ConfirmContext.Provider>
    );
};